import { formatLabor as formatLaborHelper } from "components/helpers/format";

export default function formatLabor(laborOverride, effectiveLabor) {
  const laborOverrideAsterisk = laborOverride === null ? "" : "*";

  return formatLaborHelper(effectiveLabor, laborOverrideAsterisk);
}
